import { AlertTriangleIcon, XIcon } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export const EnvironmentMessage = () => {
  const { t } = useTranslation()
  const [show, setShow] = useState(true)
  const env = import.meta.env.VITE_ENV
  const isEnvTest = env === "DEV" || env === "HML"

  if (!isEnvTest || !show) return null

  return (
    <div className="sticky top-0 z-50 flex items-center justify-center gap-2 bg-amber-500 px-4 py-1.5 text-amber-950">
      <AlertTriangleIcon className="size-4 shrink-0" />
      <p className="text-center text-sm font-medium">
        {t("common.testEnvironmentMessage")}
        <span className="ml-1.5 rounded bg-amber-600/50 px-1.5 py-0.5 text-xs font-bold uppercase">
          {env}
        </span>
      </p>
      <button
        type="button"
        onClick={() => setShow(false)}
        className="absolute right-3 rounded p-0.5 transition-colors hover:bg-amber-600/50"
        aria-label={t("common.close")}
      >
        <XIcon className="size-4" />
      </button>
    </div>
  )
}
